import type { IxcRegistrationV1ProfileKeys, IxcRegistrationV1ProfileTypeOneOfValue } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const REGISTRATION_PROFILE_BASE_PATH = getResolvedPath('/registration/profile');

export const getRegistrationProfilePath: EntityPathBuilder<IxcRegistrationV1ProfileKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return REGISTRATION_PROFILE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.profileId) {
        return undefined;
      }

      return getResolvedPath(`${REGISTRATION_PROFILE_BASE_PATH}/$profileId`, context?.keys);
    }
  }
};

export function getRegistrationProfileDetailPath(profileId: string | undefined, versionId?: string) {
  const base = getRegistrationProfilePath({ kind: 'detail', keys: { profileId } });
  if (!base) {
    return undefined;
  }

  if (versionId) {
    return `${base}?versionId=${versionId}`;
  }

  return base;
}

export function getRegistrationProfileCreatePath(profileType: IxcRegistrationV1ProfileTypeOneOfValue) {
  return getResolvedPath(`${REGISTRATION_PROFILE_BASE_PATH}/create/$profileType`, { profileType });
}

export function getRegistrationProfileEditPath(profileId: string | undefined) {
  return getResolvedPath(`${REGISTRATION_PROFILE_BASE_PATH}/$profileId/edit`, { profileId });
}
